import { EEnvTypes } from '@common/enums/env-types.enum';

export const environment = {
    production: true,
    baseHref: '/websites/builder/',
    unsplashApiUrl: 'https://login.sendpulse.com/websites/builder/api/unsplash',
    fileManagerCdnUrl: 'https://cdn.wdgtsrc.com',
    fileManagerUrl: '',
    siteServiceLink: 'https://login.sendpulse.com/landing-pages',
    type: EEnvTypes.PROD,
    aiChat: false,
};
